/**
 * Base key/value model. Typically extended to reflect a more accurate "key"
 * data type. See collections/key-string-value and collections/key-numeric-value
 */

import Brace from "backbone.brace";

const Model = Brace.Model.extend({
  idAttribute: "key",
  namedAttributes: {
    key: Object,
    value: String,
    checked: Boolean,
    enabled: Boolean,
  },
  defaults: {
    key: null,
    value: null,
    checked: false,
    enabled: true,
  },
});

export { Model as default };
